import {OrganisationDTO} from "../../app/DTO/Organisation/OrganisationDTO";
import {OrganisationAccountDTO} from "./OrganisationAccountDTO";

export class KeyCloackUserDTO {
    public id?: string;
    public firstName?: string;
    public lastName?: string;
    public username?: string;
    public email?: string;
    constructor() {
    }

    bindData(obj: any): void {
        if (obj == null) {
            return;
        }

        if (obj.id) {
            this.id = obj.id;
        }

        if (obj.firstName) {
            this.firstName = obj.firstName;
        }

        if (obj.lastName) {
            this.lastName = obj.lastName;
        }

        if (obj.username) {
            this.username = obj.username;
        }

        if (obj.email) {
            this.email = obj.email;
        }
    }
}
